import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function Rules() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Club Rules & Regulations</h1>
          <p className="text-xl text-gray-600">Essential guidelines for safe and enjoyable boating at VCA</p>
        </div>

        <div className="space-y-8">
          <Card>
            <CardContent className="p-6">
              <h2 className="text-2xl font-bold text-navy mb-4">Security & Access</h2>
              <div className="space-y-4">
                <div className="border-l-4 border-sailing-gold pl-4">
                  <h3 className="font-semibold text-gray-900 mb-2">Gate Access</h3>
                  <p className="text-gray-700">The motorized gate must remain closed at all times. Remote controls are for member exclusive use only and may not be given to non-members. Do not tamper with security lights or poles.</p>
                </div>
                <div className="border-l-4 border-sailing-gold pl-4">
                  <h3 className="font-semibold text-gray-900 mb-2">Guest Policy</h3>
                  <p className="text-gray-700">Maximum 6 guests per day per member family. Guests limited to 4 visits per financial year (May 1 - April 30) and maximum 4 days per visit. Guests must be met at the gate and signed into the visitor's book.</p>
                </div>
                <div className="border-l-4 border-sailing-gold pl-4">
                  <h3 className="font-semibold text-gray-900 mb-2">Guest Accommodation</h3>
                  <p className="text-gray-700">Overnight camping: R100/night + R30/person (12+ years). Caravan guests: R150/night + R30/person. Club caravans available for hire at R150/night + R30/person with prior arrangement.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-2xl font-bold text-navy mb-4">Water Safety & Etiquette</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">Safety Requirements</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>• Life jackets mandatory for children under 12 and dinghy/catamaran sailors</li>
                    <li>• Life jackets, bailer and paddles must be immediately available on all craft</li>
                    <li>• Annual safety inspections required for all boats by club Safety Officer</li>
                    <li>• Valid registration and certificates of fitness (COF/COC) required</li>
                    <li>• All skippers must sign out when departing and sign in on return</li>
                    <li>• No unregistered boats or unlicensed skippers permitted</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-3">Harbor Rules</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li>• Harbor area is a no wake zone - maximum 5 km/h speed limit</li>
                    <li>• Floating jetties for loading/unloading only - no overnight mooring</li>
                    <li>• Do not block slipways with trailers, cars or dinghy dollies</li>
                    <li>• Large boats must be beached or on moorings when unattended</li>
                    <li>• Power boats use perimeter channels to avoid mooring areas</li>
                    <li>• Yacht moorings require annual inspection by bosun</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-2xl font-bold text-navy mb-4">Property & Facilities</h2>
              <div className="space-y-4">
                <div className="border-l-4 border-sailing-gold pl-4">
                  <h3 className="font-semibold text-gray-900 mb-2">Caravan Sites</h3>
                  <p className="text-gray-700">Two cars per site maximum. One caravan, one shade port (max 49sqm), and one steel shed (max 9sqm) per site. Sites must be used minimum 6 times per year or may be re-allocated. No construction without committee approval and engineer's certificate.</p>
                </div>
                <div className="border-l-4 border-sailing-gold pl-4">
                  <h3 className="font-semibold text-gray-900 mb-2">Site Restrictions</h3>
                  <p className="text-gray-700">No speedboats/dinghies on sites without dispensation - use designated boat park. Shade cloth must be green or vinyl screens. No hedging allowed. Electrical connections limited to 10 amps maximum.</p>
                </div>
                <div className="border-l-4 border-sailing-gold pl-4">
                  <h3 className="font-semibold text-gray-900 mb-2">General Conduct</h3>
                  <p className="text-gray-700">Treat facilities as your own home. Use water sparingly (borehole supply only). No sprinklers/garden watering on weekends. Place refuse in trailer at gate - do not dump on neighboring farm.</p>
                </div>
                <div className="border-l-4 border-sailing-gold pl-4">
                  <h3 className="font-semibold text-gray-900 mb-2">Facilities Care</h3>
                  <p className="text-gray-700">Leave clubhouse and ablutions clean for the next person. Septic tank system - only flush what you've eaten! No tampering with club property. Behind-bar area is off-limits.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-navy text-white">
            <CardContent className="p-6">
              <h2 className="text-2xl font-bold mb-4">Membership Obligations & Additional Rules</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold mb-2">Annual Subscriptions</h3>
                  <p className="text-sm">Fees must be paid in full by June 30th each year. Late payment may result in deemed resignation. Members must remove property by August 31st if resigning, or it becomes club property.</p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Pet Policy</h3>
                  <p className="text-sm">Small dogs only, must be leashed and under control at all times. No dogs in clubhouse, ablutions, or pool areas. Visitor dogs not permitted. Club has free-roaming security dogs.</p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Boat Fees</h3>
                  <p className="text-sm">Daily slipway fee of R100 for non-registered boats. Guest boat owners must have registration, COF, and COC before launching.</p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Prohibited Items</h3>
                  <p className="text-sm">No quads or off-road motorcycles. No contractors during school holidays, Easter, or Christmas. No fishing from jetties - use designated areas only.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="text-center">
            <p className="text-gray-600 mb-4">For complete rules and regulations, please contact the committee.</p>
            <Button className="bg-sailing-gold hover:bg-yellow-500 text-navy font-semibold py-2 px-6">
              Download Full Rulebook
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
